import React, { useState, useEffect, useRef } from 'react';
import { getUsedAddressArea } from "../../service/AddressApi";  // Adjust this import path
import { queryFamiliesByArea } from "../../service/FamilyQueryApi";  // Adjust this import path for your API call
import '../general/General.css';
import { useCheckAccess, shortenKootam, maskMobile, getSubareaNameTamil } from "../../utils/Utilities";
import { Loading } from "../../components/shared";
import { useSelector } from "react-redux";
const FamilyAreaWiseListPrint = () => {
  useCheckAccess('FamilyRO');
  const tableRef = useRef();
  const user = useSelector((state) => state.user);
  const [areas, setAreas] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrictTamil, setSelectedDistrictTamil] = useState('');
  const [districtIds, setDistrictIds] = useState([]); // New state for district_tamil IDs
  const [blocks, setBlocks] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState('');
  const [subareas, setSubareas] = useState([]); // New state for subareas
  const [selectedId, setSelectedId] = useState(''); // State to hold selected area ID
  const [selectedSubareaId, setSelectedSubareaId] = useState(''); // State to hold selected subarea ID
  const [families, setFamilies] = useState([]);  // State for families data
  const [tempFamilies, setTempFamilies] = useState([]);  // State for families data
  const [loading, setLoading] = useState(false); // Loading state for the API request
  const [loadingAreas, setLoadingAreas] = useState(false);
  const [printMode, setPrintMode] = useState(false);

  // Pagination state
  const [pageNumber, setPageNumber] = useState(1);
  const defaultPageSize = 50;
  const [totalItems, setTotalItems] = useState(0);
  const formatAddress = (...parts) => parts.filter(Boolean).join(', ');



  // Fetch areas from API
  const fetchAreas = async () => {
    setLoadingAreas(true);  // Disable the button
    try {
      const response = await getUsedAddressArea();
      if (Array.isArray(response.addressAreaList)) {
        setAreas(response.addressAreaList);
      } else {
        alert("Unexpected area response format");
      }
    } catch (error) {
      console.error("Error fetching areas:", error);
      alert("Failed to fetch area data: " + error.message);
    } finally {
      setLoadingAreas(false);  // Re-enable the button
    }
  };

// Inside your component:
useEffect(() => {
  if (areas.length > 0) {
    const tamilNaduDistricts = areas
      .filter(area => area.state_tamil.replace(/\s/g, '') === 'தமிழ்நாடு')
      .map(area => ({
        district_tamil: area.district_tamil,
        district_tamil_display: area.district_tamil
      }));

    const otherStateDistricts = areas
      .filter(area => area.state_tamil.replace(/\s/g, '') !== 'தமிழ்நாடு')
      .map(area => ({
        district_tamil: area.district_tamil,
        district_tamil_display: `${area.district_tamil} (${area.state_tamil})`
      }));

    const combined = [...tamilNaduDistricts, ...otherStateDistricts];

    // Remove duplicates by `district_tamil`
    const uniqueMap = new Map();
    combined.forEach(item => {
      if (!uniqueMap.has(item.district_tamil)) {
        uniqueMap.set(item.district_tamil, item);
      }
    });

    const uniqueDistricts = Array.from(uniqueMap.values());

    setDistricts(uniqueDistricts); // each with { district_tamil, district_tamil_display }
  }
}, [areas]);



  // Update district_tamil IDs when a district_tamil is selected
  const handleDistrictChange = (e) => {
    setPageNumber(1);
    const district_tamil = e.target.value;
    setSelectedDistrictTamil(district_tamil);

    // Set the available area IDs for the selected district_tamil
    const filteredAreas = areas.filter(area => area.district_tamil === district_tamil);
    const uniqueBlocks = [...new Set(filteredAreas.map(area => area.block_tamil))];
    setBlocks(uniqueBlocks);

    // Reset subareas when district_tamil changes
    setSelectedBlock('');
    setDistrictIds([]);
    setSubareas([]);
    setSelectedId('');
    setSelectedSubareaId('');
  };
  const handleBlockChange = (e) => {
    const block = e.target.value;
    setSelectedBlock(block);
    setPageNumber(1);

    const filteredAreas = areas.filter(
      area => area.district_tamil === selectedDistrictTamil && area.block_tamil === block
    );

    const areaIds = filteredAreas.map(area => area.id);
    setDistrictIds(areaIds);

    setSelectedId('');
    setSubareas([]);
    setSelectedSubareaId('');
  };


  // Update subareas when an area ID is selected
  const handleIdChange = (e) => {
    setPageNumber(1);
    const id = e.target.value;
    setSelectedId(id);

    // Find the selected area by ID and update the subareas
    const selectedArea = areas.find(area => area.id === id);
    if (selectedArea && selectedArea.subAreas) {
      setSubareas(selectedArea.subAreas);  // Update subareas for the selected area
    } else {
      setSubareas([]);  // If no subareas found, reset subareas
    }
  };

  // Handle Subarea selection
  const handleSubareaChange = (e) => {
    setPageNumber(1);
    const subareaId = e.target.value;
    setSelectedSubareaId(subareaId);
  };

  // Submit the selected area and subarea IDs to the Family Enquiry API
  const handleSubmit = async () => {
    if (!selectedDistrictTamil && !selectedId && selectedSubareaId) {
      alert("Cannot query with only Subarea selected.");
      return;
    }

    // Prepare API parameters dynamically
    const queryParams = {
      pageNumber: 1,
      pageSize: printMode ? 10000 : defaultPageSize
    };

    if (selectedDistrictTamil) {
      queryParams.district = selectedDistrictTamil;
    }
    if (selectedBlock) {
      queryParams.block = selectedBlock;
    }
    if (selectedId) {
      queryParams.areaId = selectedId;
    }
    if (selectedSubareaId) {
      queryParams.subareaId = selectedSubareaId;
    }

    setLoading(true);
    try {
      const response = await queryFamiliesByArea(queryParams);

      if (response && response.families && Array.isArray(response.families)) {
        setTotalItems(response.totalItems || 0); // Set the total items for pagination
        setFamilies(response.families);
      } else {
        alert("No families found.");
        setFamilies([]);
      }
      if (response && response.tempFamilies && Array.isArray(response.tempFamilies)) {
        setTempFamilies(response.tempFamilies);
      } else {
        setTempFamilies([]);
      }
    } catch (error) {
      console.error("Error fetching families:", error);
      setFamilies([]);
      setTempFamilies([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDistrictTamil || selectedBlock || selectedId || selectedSubareaId) {
      handleSubmit();
    }
  }, [printMode, pageNumber]);


  const handlePrint = () => {
    const content = tableRef.current.innerHTML;
    const printWindow = window.open('', '', 'width=900,height=600');
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Families</title>
          <style>
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #000; padding: 8px; }
            h3 { margin-top: 30px; }
          </style>
        </head>
        <body>
          <h1>குடும்பப் பட்டியல்</h1>
          ${content}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  /*
    const groupFamiliesByAddress = (list) => {
      const groups = {};
      list.forEach(family => {
        const subarea = getSubareaNameTamil(family.permanentAddressAreaId, family.permanentSubareaId, areas);
  
        // Filter out falsy parts before joining
        const key = [subarea, family.permanentAddressName_tamil, family.permanentAddressBlock_tamil, family.permanentAddressDistrict_tamil]
          .filter(Boolean)  // removes null, undefined, '', false
          .join(', ');
  
        if (!groups[key]) groups[key] = [];
        groups[key].push(family);
      });
      return groups;
    };*/

  const groupFamiliesByAddress = (list) => {
    const groups = {};
    list.forEach(family => {
      const subarea = getSubareaNameTamil(family.permanentAddressAreaId, family.permanentSubareaId, areas);

      // Create the address parts array
      const parts = [
        subarea,
        family.permanentAddressName_tamil,
        family.permanentAddressBlock_tamil,
        family.permanentAddressDistrict_tamil
      ].filter(Boolean); // remove falsy values

      // Remove duplicates while preserving order
      const uniqueParts = [...new Set(parts)];

      const key = uniqueParts.join(', ');

      if (!groups[key]) groups[key] = [];
      groups[key].push(family);
    });
    return groups;
  };


  // Function to render the family table
  const renderGroupedTables = () => {
    const combinedList = [...families];

    combinedList.sort((a, b) => {
      const areaCompare = String(a.permanentAddressAreaId).localeCompare(String(b.permanentAddressAreaId));
      if (areaCompare !== 0) return areaCompare;

      const subareaA = getSubareaNameTamil(a.permanentAddressAreaId, a.permanentSubareaId, areas);
      const subareaB = getSubareaNameTamil(b.permanentAddressAreaId, b.permanentSubareaId, areas);

      const subareaCompare = subareaA.localeCompare(subareaB);
      if (subareaCompare !== 0) return subareaCompare;

      return Number(a.id) - Number(b.id);
    });



    const grouped = groupFamiliesByAddress(combinedList);

    return Object.keys(grouped).map((key, idx) => (
      <div key={idx}>
        <h3>{key}</h3>
        <table className="print-table">
          <thead>
            <tr>
              <th>விண்ணப்பம்</th>
              <th>எண்</th>
              <th>தலைவர்</th>
              <th>வரி ஆண்டு</th>
            </tr>
          </thead>
          <tbody>
            {grouped[key].map((family, index) => (
              <tr key={index}>
                <td>{family.status === 'active' ? '✓' : 'X'}</td>
                <td>{family.id} ({shortenKootam(family.kootamName, family.customGroup)})</td>
                <td>{family.familyHeadFirstName} {family.familyHeadLastName}
                  ({maskMobile(family.familyHeadMobile)}{family.familyHeadMobile2 ? ` / ${maskMobile(family.familyHeadMobile2)}` : ''})
                </td>
                <td>{family.pongalTaxUptoYear}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ));
  };



  // Handle page navigation (next/previous)
  const handleNextPage = () => {
    if (pageNumber * defaultPageSize < totalItems) {
      setPageNumber(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(prev => prev - 1);
    }
  };

  return (
    <div className="general_parent">
      <div className="general_container">
        <div className="general_body">
          <h1>பகுதி வாரியாக குடும்பப் பட்டியல் அச்சிட</h1>
          <br />
          <button onClick={fetchAreas} disabled={loadingAreas}>
            {loadingAreas ? 'ஏற்றுகிறது...' : 'முகவரி பட்டியலை ஏற்றவும்'}
          </button>

          <br />

          {districts.length > 0 && (
            <form onSubmit={handleSubmit}>
              <div className="auth_element">
                <label>மாவட்டம்:</label>
                <select value={selectedDistrictTamil} onChange={handleDistrictChange} className="auth_select">
                  <option value="">-- மாவட்டம் தேர்ந்தெடுக்கவும் --</option>
                  {districts.map(d => (
                    <option key={d.district_tamil} value={d.district_tamil}>
                      {d.district_tamil_display}
                    </option>
                  ))}
                </select>
              </div>

              {selectedDistrictTamil && blocks.length > 0 && (
                <div className="auth_element">
                  <label>வட்டம்:</label>
                  <select value={selectedBlock} onChange={handleBlockChange} className="auth_select">
                    <option value="">-- வட்டம் தேர்ந்தெடுக்கவும் --</option>
                    {blocks.map(block => (
                      <option key={block} value={block}>{block}</option>
                    ))}
                  </select>
                </div>
              )}

              {selectedBlock && districtIds.length > 0 && (
                <div className="auth_element">
                  <label>அஞ்சல்:</label>
                  <select value={selectedId} onChange={handleIdChange} className="auth_select">
                    <option value="">-- அஞ்சல் தேர்ந்தெடுக்கவும் --</option>
                    {districtIds.map(id => {
                      const area = areas.find(a => a.id === id);
                      return (
                        <option key={id} value={id}>
                          {`${area.name_tamil} (${area.pincode})`}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}

              {/* Show Subareas for the selected Area ID */}
              {selectedId && Array.isArray(subareas) && subareas.length > 0 && (
                <div className="auth_element">
                  <label>ஊர் : </label>
                  <select value={selectedSubareaId} onChange={handleSubareaChange}
                    className="auth_select">
                    <option value="">-- ஊர் தேர்ந்தெடுக்கவும்--</option>
                    {subareas.map(subarea => {
                      const transformedName = subarea.name_tamil
                        ?.split('|')
                        .reverse()
                        .join(',');

                      return (
                        <option key={subarea.id} value={subarea.id}>
                          {transformedName}
                        </option>
                      );
                    })}

                  </select>
                </div>
              )}

              <div style={{ margin: '1rem 0' }}>
                <label>
                  <input
                    type="checkbox"
                    checked={printMode}
                    onChange={() => setPrintMode(prev => !prev)}
                  /> ஊர் வாரியாகக் காட்டு (தேவைப்படும்போது மட்டும் பயன்படுத்தவும்.)
                </label>
              </div>

              <button type="button" onClick={handleSubmit}>குடும்ப விவரங்களை பெறவும்</button>
              {user?.roles?.includes('FamilyAdmin') && printMode && <button onClick={handlePrint}>🖨️ அச்சிடு</button>}

            </form>
          )}

          {!printMode && families.length > 0 && (
            <div className="pagination-controls">
              <button onClick={handlePrevPage} disabled={pageNumber <= 1}>முந்தைய பக்கம்</button>
              <span>பக்கம் {pageNumber} (மொத்தம்-{Math.ceil(totalItems / defaultPageSize)})</span>
              <button onClick={handleNextPage} disabled={pageNumber * defaultPageSize >= totalItems}>அடுத்த பக்கம்</button>
            </div>
          )}

          {loading ? (
            <Loading />
          ) : (
            <div ref={tableRef}>
              {printMode ? (
                renderGroupedTables()
              ) : (
                [...families, ...(pageNumber === 1 ? tempFamilies : [])].length > 0 ? (
                  <table className="print-table">
                    <thead>
                      <tr>
                        <th>விண்ணப்பம்</th>
                        <th>எண்</th>
                        <th>தலைவர்</th>
                        <th>முகவரி</th>
                        <th>வரி ஆண்டு</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...families, ...(pageNumber === 1 ? tempFamilies : [])].map((family, index) => (
                        <tr key={index}>
                          <td>{family.status === 'active' ? '✓' : 'X'}</td>
                          <td>{family.id} ({shortenKootam(family.kootamName, family.customGroup)})</td>
                          <td>
                            {family.familyHeadFirstName} {family.familyHeadLastName}
                            ({maskMobile(family.familyHeadMobile)}
                            {family.familyHeadMobile2 ? `/${maskMobile(family.familyHeadMobile2)}` : ''})
                          </td>

                          <td>
                            {formatAddress(family.permanentAddressName_tamil, family.permanentAddressBlock_tamil, family.permanentAddressDistrict_tamil)}
                            {family.tempAddressAreaId && (
                              <>
                                <br />
                                {'T: '}
                                {formatAddress(
                                  getSubareaNameTamil(family.tempAddressAreaId, family.tempSubareaId, areas),
                                  family.tempAddressName_tamil,
                                  family.tempAddressBlock_tamil,
                                  family.tempAddressDistrict_tamil
                                )}
                              </>
                            )}
                          </td>

                          <td>{family.pongalTaxUptoYear}</td>
                        </tr>

                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>குடும்பங்கள் எதுவும் இல்லை.</p>
                )
              )}

            </div>
          )}
          {/* Pagination Controls */}

          {!printMode && families.length > 0 && (
            <div className="pagination-controls">
              <button onClick={handlePrevPage} disabled={pageNumber <= 1}>முந்தைய பக்கம்</button>
              <span>பக்கம் {pageNumber} (மொத்தம்-{Math.ceil(totalItems / defaultPageSize)})</span>
              <button onClick={handleNextPage} disabled={pageNumber * defaultPageSize >= totalItems}>அடுத்த பக்கம்</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FamilyAreaWiseListPrint;
